// extracted by mini-css-extract-plugin
export default {"page":"HostReviews_page__JpGt-","pageHeading":"HostReviews_pageHeading__wOzyv","viewMenu":"HostReviews_viewMenu__qVIxq"};